import { createResponsesImage } from '../createResponsesImage/createResponsesImage';
import component from './ResponsesImageNothingFoundSvg';

export const ResponsesImageNothingFound = createResponsesImage({
  name: 'ResponsesImageNothingFound',
  component,
});
